import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { makeStyles } from "@mui/styles";
import React from "react";
// import { useDispatch, useSelector } from "react-redux";
// import { useNavigate } from "react-router-dom";
import { PRIMARY } from "../../../utils/constansColors";
// import { Gap, MyButton } from "../../atoms";
import { useParams } from "react-router-dom";
import { Link } from "react-router-dom";

const useStyles = makeStyles({
  root: {
    "& .Mui-selected": {
      backgroundColor: PRIMARY,
      color: "white",
      border: "none",
    },
  },
  tableBody: {
    backgroundColor: "#FFFFFF",
    width: "100%",
    tableLayout: "fixed",
    marginTop: "10px",
    fontSize: "25px",
    borderRadius: 5,
  },
  tableHeader: {
    backgroundColor: "transparant",
    width: "100%",
    tableLayout: "fixed",
    marginTop: "10px",
    color: "#757575",
    fontWeight: 700,
  },
});

const columnData = [
  { no: 0, name: "No" },
  { no: 1, name: "Nama Daerah" },
  { no: 2, name: "Exco" },
  { no: 3, name: "Target" },
  { no: 4, name: "Capaian" },
  { no: 5, name: "Hasil" },
];
export default function BasicTable(dataProps) {
  const classes = useStyles();
	let params = useParams();
	const getSubValue = (id,key) =>{
		let value = "";
		for(let i=0;i<dataProps?.dataSubArea?.length;i++){
			if(id === dataProps?.dataSubArea[i].id){
				value = dataProps?.dataSubArea[i][key]
			}
		}
		return value
	}
  const markers = []
	dataProps?.dataPengurusAll?.forEach((data)=>{
		markers.push({
			id_provinsi:data?.id_provinsi,
			nama_provinsi:data?.nama_provinsi,
			id_kabkot:data?.id_kabkot,
			nama_kab_kot:data?.nama_kab_kot,
			id_kecamatan:data?.id_kecamatan,
			nama_kecamatan:data?.nama_kecamatan,
			lat:data?.latitude,
			lon:data?.longitude,
			sk_pengurus:data?.info_dokumen?.dokumen_sk_pengurus,
			dokumen:data?.info_dokumen,
			jumlah_pengurus: (params?.tingkatExcoId === "2")? data?.jumlah_pengurus : (params?.tingkatExcoId === "3") ? data?.jumlah_pengurus_kabkot : data?.jumlah_pengurus_kecamatan,
			jumlah_pengurus_perempuan: (params?.tingkatExcoId === "2")? data?.jumlah_pengurus_perempuan : (params?.tingkatExcoId === "3") ? data?.jumlah_pengurus_kabkot_perempuan : data?.jumlah_pengurus_kecamatan_perempuan,
			jumlah_sub: (params?.tingkatExcoId === "2")? getSubValue(data?.id_provinsi,"id_sub") : (params?.tingkatExcoId === "3") ? getSubValue(data?.id_kabkot,"id_sub") : 0,
			jumlah_sub_ms: (params?.tingkatExcoId === "2")? getSubValue(data?.id_provinsi,"sub_ms") : (params?.tingkatExcoId === "3") ? getSubValue(data?.id_kabkot,"sub_ms") : 0,
			jumlah_sub_total: (params?.tingkatExcoId === "2")? getSubValue(data?.id_provinsi,"sub_total") : (params?.tingkatExcoId === "3") ? getSubValue(data?.id_kabkot,"sub_total") : 0,
		})
	})

	const persentase = (penyebut,pembagi) =>{
		let persen = 0
		if(parseInt(pembagi) !== 0 && parseInt(penyebut) !== 0){
			persen = ((parseInt(penyebut)/parseInt(pembagi))*100).toFixed(0)
		}
		return persen
	}

	const hasil = (data) =>{
    let result = "TMS"
    if(data.jumlah_pengurus > 0 && data?.sk_pengurus === 1 && parseFloat(persentase(data.jumlah_sub_ms,data.jumlah_sub))>=75){
      result = "MS"
    }
    return result
  }
  return (
    <>
      <TableContainer>
        <Table
          sx={{ minWidth: 650 }}
          aria-label="simple table"
          className={classes.tableHeader}
        >
          <TableHead>
            <TableRow>
              {columnData.map((item, key) => {
                return (
                  <TableCell
                    key={key}
                    style={{
                      fontWeight: 700,
                      color: "#757575",
											textAlign:'center',
                      width: item.name === "No" ? "5%" : "",
                    }}
                  >
										<div>{item.name}</div>
                  </TableCell>
                );
              })}
            </TableRow>
          </TableHead>
        </Table>
				<div style={{height:"400px", minWidth:'650px', overflowY:'auto', overflowX:'hidden'}}>
        {markers?.map((item, index) => {
          let number = index + 1;
          return (
            <Table
              sx={{ minWidth: 650 }}
              aria-label="simple table"
              className={classes.tableBody}
              key={"tab-" + index}
            >
              <TableBody>
                <TableRow key={item.id}>
                  <TableCell style={{ width: "5%" }}>{number}</TableCell>
                  <TableCell style={{ width: "" }}>
									{(params?.tingkatExcoId === "2")?
                    <div>
                      <span style={{ fontSize: "10px", color: "#757575" }}>Provinsi :</span> <br/>
                      <Link to={'/pengurus/3/'+item.id_provinsi+'/0'}>{item.nama_provinsi}</Link>
                    </div>
									:null}
									{(params?.tingkatExcoId === "3")?
                    <div>
                      <span style={{ fontSize: "10px", color: "#757575" }}>Provinsi :</span> <br/>
                      <Link to={'/pengurus/3/'+item.id_provinsi+'/0'}>{item.nama_provinsi}</Link>
                      <br/>
                      <span style={{ fontSize: "10px", color: "#757575" }}>Kab/Kota :</span> <br/>
                      <Link to={'/pengurus/4/'+item.id_provinsi+'/'+item.id_kabkot}>{item.nama_kab_kot}</Link>
                    </div>
									:null}
									{(params?.tingkatExcoId === "4")?
                    <div>
                      <span style={{ fontSize: "10px", color: "#757575" }}>Provinsi :</span> <br/>
                      <Link to={'/pengurus/3/'+item.id_provinsi+'/0'}>{item.nama_provinsi}</Link>
                      <br/>
                      <span style={{ fontSize: "10px", color: "#757575" }}>Kab/Kota :</span> <br/>
                      <Link to={'/pengurus/4/'+item.id_provinsi+'/'+item.id_kabkot}>{item.nama_kab_kot}</Link>
                      <br/>
                      <span style={{ fontSize: "10px", color: "#757575" }}>Kecamatan :</span> <br/>
                      {item.nama_kecamatan}
                    </div>
									:null}
									</TableCell>
                  <TableCell style={{ textAlign:'left' }}>
                    <span style={{ fontSize: "10px", color: "#757575" }}>
                      Exco :
                    </span><br/>
                    <span style={(item.sk_pengurus === 1 && item.jumlah_pengurus > 0)? {color: "green", fontWeight:'bold'}:{color: "red", fontWeight:'bold'}}>
                      {(item.sk_pengurus === 1 && item.jumlah_pengurus > 0)? "Ada" : "Tidak Ada"}
                    </span><br/>
                    <span style={{ fontSize: "10px", color: "#757575" }}>
                      Jumlah Pengurus :
                    </span><br/>
                    <span style={{ fontWeight: "bold" }}>
                      {parseInt(item?.jumlah_pengurus)}
                    </span><br/>
                    <span style={{ fontSize: "10px", color: "#757575" }}>
                      Jumlah Pengurus Perempuan:
                    </span><br/>
                    <span style={{ fontWeight: "bold" }}>
                      {parseInt(item?.jumlah_pengurus_perempuan)} ({persentase(parseInt(item?.jumlah_pengurus_perempuan),parseInt(item?.jumlah_pengurus))}%)
                    </span><br/>
                  </TableCell>
                  {(params?.tingkatExcoId !== "4")?
                  <TableCell style={{ textAlign:'left' }}>
                    <span style={{ fontSize: "10px", color: "#757575" }}>
                      Jumlah {(params?.tingkatExcoId === "2")?"Kab/Kota":(params?.tingkatExcoId === "3")?"Kecamatan":" "} :
                    </span><br/>
                    <span style={{ fontWeight: "bold" }}>
                      {parseInt(item?.jumlah_sub)}
                    </span><br/>
                    <span style={{ fontSize: "10px", color: "#757575" }}>
                      Target Partai Buruh (75%):
                    </span><br/>
                    <span style={{ fontWeight: "bold" }}>
                      {Math.ceil(item?.jumlah_sub*0.75)}
                    </span><br/>
                    <span style={{ fontSize: "10px", color: "#757575" }}>
                      Standar KPU {(params?.tingkatExcoId === "2")?"(75%)":"(50%)"}:
                    </span><br/>
                    <span style={{ fontWeight: "bold" }}>
                      {(params?.tingkatExcoId === "2")?Math.ceil(item?.jumlah_sub*0.75):Math.ceil(item?.jumlah_sub*0.50)}
                    </span><br/>
                  </TableCell>
                  :<TableCell style={{ textAlign:'left' }}></TableCell>
                  }
                  {(params?.tingkatExcoId !== "4")?
                  <TableCell style={{ textAlign:'left' }}>
                    <span style={{ fontSize: "10px", color: "#757575" }}>
                      Jumlah Exco {(params?.tingkatExcoId === "2")?"Kab/Kota":(params?.tingkatExcoId === "3")?"Kecamatan":" "} :
                    </span><br/>
                    <span style={{ fontWeight: "bold" }}>
                      {parseInt(item?.jumlah_sub_ms)}
                    </span><br/>
                    <span style={{ fontSize: "10px", color: "#757575" }}>
                      Capaian Target PB :
                    </span><br/>
                    <span style={{ fontWeight: "bold" }}>
                      {persentase(item.jumlah_sub_ms,Math.ceil(item.jumlah_sub*0.75))}% ({((item.jumlah_sub_ms-Math.ceil(item.jumlah_sub*0.75)>0))?"+":""}{item.jumlah_sub_ms-Math.ceil(item.jumlah_sub*0.75)})
                    </span><br/>
                    <span style={{ fontSize: "10px", color: "#757575" }}>
                      Capaian Standar KPU :
                    </span><br/>
                    {(params?.tingkatExcoId === "2")?
                    <span style={{ fontWeight: "bold" }}>
                      {persentase(item.jumlah_sub_ms,Math.ceil(item.jumlah_sub*0.75))}% ({((item.jumlah_sub_ms-Math.ceil(item.jumlah_sub*0.75)>0))?"+":""}{item.jumlah_sub_ms-Math.ceil(item.jumlah_sub*0.75)})
                    </span>
                    :
                    <span style={{ fontWeight: "bold" }}>
                      {persentase(item.jumlah_sub_ms,Math.ceil(item.jumlah_sub*0.5))}% ({((item.jumlah_sub_ms-Math.ceil(item.jumlah_sub*0.50)>0))?"+":""}{item.jumlah_sub_ms-Math.ceil(item.jumlah_sub*0.50)})
                    </span>
                    }
                  </TableCell>
                  :<TableCell style={{ textAlign:'left' }}></TableCell>
                  }
                  {(params?.tingkatExcoId !== "4")?
                  <TableCell style={(hasil(item)==="MS")?{ color: "white",textAlign:'center', fontWeight: "bold", backgroundColor:'green'}:{ color: "white", textAlign:'center', fontWeight: "bold", backgroundColor:'red'}}>
										{hasil(item)}
                  </TableCell>
                  :<TableCell style={{ textAlign:'left' }}></TableCell>
                  }

                </TableRow>
              </TableBody>
            </Table>
          );
        })}
				</div>
      </TableContainer>
    </>
  );
}
